<template>
  <div class="p-4">
    <el-table
      :data="payments.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column label="Customer" sortable>
        <template slot-scope="scope">{{ scope.row.user.email }}</template>
      </el-table-column>
      <el-table-column label="Order No." sortable>
        <template slot-scope="scope">{{ scope.row.order.invoice_id }}</template>
      </el-table-column>
      <el-table-column label="Payment Method" sortable>
        <template slot-scope="scope">{{ scope.row.paymentMethod.name }}</template>
      </el-table-column>
      <el-table-column label="Amount paid" sortable>
        <template slot-scope="scope">{{ scope.row.total }}</template>
      </el-table-column>
      <el-table-column prop="failed" label="Paid?">
        <template slot-scope="scope">
          <span v-if="scope.row.failed === false">
            <el-tag size="small" type="success">Paid</el-tag>
          </span>
          <span v-else>
            <el-tag size="small" type="danger">Failed</el-tag>
            <el-button size="small" type="text" class="text-l text-red-500 el-icon-warning-outline"
                       @click="openPaymentDetails(scope.row)"> See Reason</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-5 mb-5 float-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      :current-page="pagination.page"
      :page-size="pagination.perPage"
      :page-count="pagination.lastPage"
      :total="pagination.total">
    </el-pagination>
  </div>
</template>

<script>

import { flatMap } from 'lodash';

export default {
  name: 'Payments',
  components: { },
  data() {
    return {
      search: '',
      page: 1,
      limit: 20,
    };
  },
  computed: {
    payments() {
      return flatMap(this.$store.state.PaymentModule.payments);
    },
    pagination() {
      return this.$store.state.OrderModule.pagination;
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    viewPayment(id) {
      this.$router.push(`/ecommerce/payments/${id}/details`);
    },
    openPaymentDetails(failedPayment) {
      this.$alert(failedPayment.reason, 'Reason for failure', {
        confirmButtonText: 'Close',
      });
    },
    getPayments() {
      try {
        this.$store.dispatch('PaymentModule/Payment/fetchAllPayments', { page: this.page, limit: this.limit });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
    handleSizeChange(args) {
      this.limit = args;
      this.getPayments();
    },
    handlePageChange(args) {
      this.page = args;
      this.getPayments();
    },
  },
};
</script>

<style scoped>

</style>
